module.exports = __webpack_public_path__ + "static/logo-efa1a95d04259e5a956845bdbae63547.png";